import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';
import {
  FormGroup,
  Input,
  Label,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { fetchUserProfile } from '../actions/Auth';

import {
  APIacceptUploadPageTerms,
  APIloadUploadPageTerms,
} from '../api/UploadPages';
import {
  APIacceptShareTerms,
  APIloadShareTerms,
} from '../api/Shares';
import {
  APIacceptTerms,
  APIloadTerms,
} from '../api/User';

import ErrorBoundary from './ErrorBoundary';
import Loading from './Loading';
import ProcessingSpinner from './ProcessingSpinner';

const TermsModal = ({
  dispatch,
  handleClose,
  profile,
  share,
  uploadPage,
}) => {
  const [accepted, setAccepted] = useState(false);
  const [terms, setTerms] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    const loadTerms = async () => {
      setLoading(true);
      if (share) {
        const response = await APIloadShareTerms(share.uuid);
        setTerms(response);
      } else if (uploadPage) {
        const response = await APIloadUploadPageTerms(uploadPage.uuid);
        setTerms(response);
      } else if (profile?.uuid) {
        const response = await APIloadTerms(profile.uuid);
        setTerms(response);
      }
      setLoading(false);
    };
    if (terms === '' && !loading) {
      loadTerms();
    }
  }, [profile, share, uploadPage, terms, loading]);

  const handleSave = async () => {
    setSaving(true);
    if (share) {
      await APIacceptShareTerms(share.uuid);
      if (share.require_accept_document) {
        window.location.reload();
      }
    } else if (uploadPage) {
      await APIacceptUploadPageTerms(uploadPage.uuid);
      if (uploadPage.require_accept_document) {
        window.location.reload();
      }
    } else {
      await APIacceptTerms(profile.uuid);
    }
    if (!share?.require_accept_document && !uploadPage?.require_accept_document) {
      dispatch(fetchUserProfile());
      setSaving(false);
      handleClose();
    }
  };

  const handleChange = (e) => {
    const { checked } = e.target;
    setAccepted(checked);
  };

  return (
    <ErrorBoundary>
      <ModalHeader>
        {intl.formatMessage({ defaultMessage: 'Accept Terms & Conditions' })}
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <Loading />
        ) : (
          Parser(terms)
        )}
      </ModalBody>
      <ModalFooter>
        {!loading && (
          <div className="buttons-group">
            <FormGroup check>
              <Label htmlFor="accept-checkbox" check>
                <Input
                  type="checkbox"
                  id="accept-checkbox"
                  name="accept"
                  value={true}
                  checked={accepted}
                  onChange={handleChange}
                />
                {intl.formatMessage({ defaultMessage: 'Accept Terms and Conditions' })}
              </Label>
            </FormGroup>
            <Button
              color="primary"
              disabled={saving || !accepted}
              onClick={handleSave}
            >
              <ProcessingSpinner show={saving} />
              {saving ? (
                intl.formatMessage({ defaultMessage: 'Saving' })
              ) : (
                intl.formatMessage({ defaultMessage: 'Accept' })
              )}
            </Button>
          </div>
        )}
      </ModalFooter>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

TermsModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  share: PropTypes.object,
  uploadPage: PropTypes.object,
};

TermsModal.defaultProps = {
  share: null,
  uploadPage: null,
};

export default connect(mapStateToProps)(TermsModal);
